import { reactive, toRefs } from 'vue';
import { publicService } from '@/api/';
// import { tools } from '@/utils/tools';
// 最新的字段图表

import { QfeiIconSingleLineTextOutlined, QfeiIconMultiLineTextOutlined, QfeiIconSingleSelectionOutlined, QfeiIconMultipleSelectionOutlined, QfeiIconDropDownSingleSelectionOutlined, QfeiIconDropDownMultipleSelectionOutlined, QfeiIconCustomerOutlined, QfeiIconNumberOutlined, QfeiIconDateOutlined, QfeiIconDateRangeOutlined, QfeiIconCascadingSelectionOutlined, QfeiIconAmountOutlined, QfeiIconDepartmentOutlined, QfeiIconPercentageOutlined, QfeiIconHyperlinkOutlined, QfeiIconFindAssociationOutlined, QfeiIconAutoIncrementCodeOutlined, QfeiIconAttachmentOutlined, QfeiIconReferenceFieldOutlined, QfeiIconCalculationTypeOutlined, QfeiIconRichTextOutlined, QfeiIconSubFormOutlined, QfeiIconComponentOutlined, QfeiIconReviewAuditOutlined, QfeiIconContainerOutlined, QfeiIconAssociatedRecordsOutlined } from '@qfei-design/icons-vue';
export default function useFields() {
  const data = reactive({
    list: [],
    enableList: [],
    searchList: [],
    showCols: [],
    showList: [],
    fieldIconMapping: {
      0: QfeiIconSingleLineTextOutlined,
      1: QfeiIconMultiLineTextOutlined,
      2: QfeiIconSingleSelectionOutlined,
      3: QfeiIconMultipleSelectionOutlined,
      4: QfeiIconDropDownSingleSelectionOutlined,
      5: QfeiIconDropDownMultipleSelectionOutlined,
      6: QfeiIconCustomerOutlined,
      7: QfeiIconNumberOutlined,
      8: QfeiIconDateOutlined,
      9: QfeiIconDateRangeOutlined,
      10: QfeiIconCascadingSelectionOutlined,
      11: QfeiIconHyperlinkOutlined,
      12: QfeiIconFindAssociationOutlined,
      13: QfeiIconAutoIncrementCodeOutlined,
      16: QfeiIconAmountOutlined,
      18: QfeiIconAttachmentOutlined,
      21: QfeiIconReferenceFieldOutlined,
      22: QfeiIconDepartmentOutlined,
      23: QfeiIconPercentageOutlined,
      24: QfeiIconCalculationTypeOutlined,
      25: QfeiIconFindAssociationOutlined,
      26: QfeiIconRichTextOutlined,
      27: QfeiIconSubFormOutlined,
      35: QfeiIconSubFormOutlined,
      30: QfeiIconAssociatedRecordsOutlined,
      31: QfeiIconReviewAuditOutlined,
      60: QfeiIconContainerOutlined,
      100: QfeiIconComponentOutlined
    },
    sysFieldListLens: true
  });
  // 获取字段列表数据
  const getFields = async (params) => {
    data.list = [];
    data.enableList = [];
    data.searchList = [];
    if (params) {
      try {
        const json = await publicService.getField(params);
        const res = json.result || [];
        if (res?.records?.length) {
          data.list = res?.records;
          const sortList = data.list?.filter((i) => i.isEnabled === true)?.sort((a, b) => (b?.sort !== '' && b?.sort !== null) - (a?.sort !== '' && a?.sort !== null) || a?.sort - b?.sort);
          data.searchList = JSON.parse(JSON.stringify(sortList));
          // data.addList = data.searchList. && //
          data.enableList = sortList?.map((item) => {
            if (item.fieldExt && [2, 3, 4, 5, 10]?.indexOf(item.fieldType) > -1) {
              item.fieldExt = JSON.stringify(JSON.parse(item.fieldExt)?.filter((i) => i.isEnabled));
            }

            return item;
          });
          data.showCols = data.enableList?.filter((el) => el.fieldType !== 18);
          data.showList = data.enableList?.filter((el) => el.listShow);
        }
        return data;
      } catch (e) {
        console.log(265, e);
        return [];
      }
    } else {
      return [];
    }
  };

  const getFieldLabel = (v, fieldExt, fieldType) => {
    // console.log(65, v, fieldExt, fieldType);
    if (!v && !fieldExt) return v ?? '-';
    const ext = JSON.parse(fieldExt);
    let fields = undefined;
    // 单选
    if (fieldType === 2 || fieldType === 4) {
      fields = ext?.find((el) => el.value == v);
      return fields?.label || v || '-';
    }
    // 多选
    if (fieldType === 3 || fieldType === 5) {
      const val = v + '';
      fields = ext?.filter((el) => val.split(',')?.indexOf(el.value) > -1);
      return (fields && fields.length && fields.map((el) => el.label)?.join('/')) || v || '-';
    }
    // 级联选择
    if (fieldType === 10) {
      // 正在开发中
      const kArr = v?.split('/') || [];
      // const k = kArr[kArr.length - 1];
      // // console.log(86, k, kArr);
      // const val = tools.getTreeDeepArr(k, ext);
      // const text = val?.iLabel?.join('/');
      // console.log(88, val.iLabel, text, k);
      // 第二种方式
      let text = '';
      let curChildren = ext;
      for (let index = 0; index < kArr?.length; index++) {
        const element = kArr[index];
        const cur = curChildren?.find((el) => el.value === element);
        curChildren = cur?.children || [];
        if (cur) text += `${index ? '/' : ''}${cur.label}`;
      }
      return (text || v) ?? '-';
    }
    // fields = ext?.filter((el) => val.split(',')?.indexOf(el.value) > -1);
    // console.log(67, v, list);
    return v ?? '';
  };
  // 系统字段-自定义字段排序   0 系统字段 1 基础字段 2 自定义字段
  const moveTypeOneToEnd = (_array) => {
    if (!_array?.length) return [];
    // 分离出type不等于0的元素
    const nonTypeOne = _array.filter((item) => item.type !== 0);
    // 分离出type等于0的元素
    const typeOne = _array.filter((item) => item.type === 0);
    // 如果有type为0的元素，给第一个添加标识
    if (typeOne.length > 0) {
      typeOne[0] = {
        ...typeOne[0],
        isFirstTypeOne: nonTypeOne?.length ? true : false // 添加首个type=0的标识
      };
    }
    // 合并数组，type不等于0的在前，等于0的在后
    return [...nonTypeOne, ...typeOne];
  };
  //下拉搜索
  const handleSearch = (val, fieldList) => {
    const getSysFieldList = fieldList?.filter((item) => item.label?.indexOf(val) > -1 && item.type == 0);
    data.sysFieldListLens = getSysFieldList?.length ? true : false;
  };
  const resetSearchList = () => {
    data.sysFieldListLens = true;
  };
  return {
    moveTypeOneToEnd,
    getFields,
    getFieldLabel,
    handleSearch,
    resetSearchList,
    ...toRefs(data)
  };
}
